export const AUTOSCALING_REMOVAL_DISABLED_LABEL =
  'autoscaling.cast.ai/removal-disabled';

export const DEDICATED_NODE_LABEL = 'scheduling.cast.ai/dedicated-node';

export const TEST_NODE_LABEL_KEY = 'provisioner.cast.ai/test-node';
export const KUBERNETES_ARCHITECTURE_LABEL_KEY = 'kubernetes.io/arch';

export const KARPENTER_NODEPOOL_LABEL_KEY = 'karpenter.sh/nodepool';
export const AKS_AGENTPOOL_LABEL_KEY = 'kubernetes.azure.com/agentpool';
export const EKS_NODEGROUP_LABEL_KEY = 'eks.amazonaws.com/nodegroup';
export const GKE_NODEPOOL_LABEL_KEY = 'cloud.google.com/gke-nodepool';
